import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { useNetworkByName } from '../../hooks/useNetworks';
import { LoadingSpinner } from '../common/LoadingSpinner';

export const WhiteLabelLayout = () => {
  const { networkName } = useParams();
  const { network, loading } = useNetworkByName(networkName);

  if (loading) return <LoadingSpinner />;
  if (!network) return <div className="alert alert-danger m-4">Network not found</div>;

  return (
    <div className="app-container">
      <Header />
      {network.imageUrl && (
        <div style={{ 
          backgroundImage: 'url(' + network.imageUrl + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '300px',
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            background: 'rgba(255,255,255,0.95)',
            padding: '20px',
            borderRadius: '8px'
          }}>
            {network.logoUrl && (
              <img src={network.logoUrl} alt={network.name} style={{ height: '60px', marginBottom: '10px' }} />
            )}
            <h1 className="mb-0">{network.name}</h1>
          </div>
        </div>
      )}
      <div className="container my-4">
        <Outlet context={{ network }} />
      </div>
      <Footer />
    </div>
  );
};
